import ExportWorkflow from '../../../../components/workflows/general/export-workflow';

class ExportRsvps extends ExportWorkflow {
    constructor(Alert, $http, $uibModal, $translate) {
        super('rsvps', Alert, $http, $uibModal, $translate);
        this.key = `export-rsvps`;
        this.level = 'selected';
        this.icon = 'upload';
        this.title = 'Export Guests';
    }

    action(payload, store) {
        super.action(payload, store).finally(() => {
            store.commit('setSelectAll', false);
        });
    }
}

angular
    .module('festzelt-os.guestlists')
    .factory('exportRsvps', [
        'Alert',
        '$http',
        '$uibModal',
        '$translate',
        (Alert, $http, $uibModal, $translate) => new ExportRsvps(Alert, $http, $uibModal, $translate)
    ])



// WEBPACK FOOTER //
// ./src/app/pages/guestlists/workflows/general/export-rsvps.js